import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ReinforcerWeightGraph2 from 'src/assets/images/reinforcer-weight-graph2.png';
import colors from 'src/styles/equalution/colors';
import { getGoalSummary } from './utils';

interface ReinforcerWeightGoalProps {
  buttonClick: () => void;
  buttonText: string;
  goalId: number;
  targetWeight: number;
  currentWeight: number;
}

export const ReinforceFatLossWithTarget: FC<
  ReinforcerWeightGoalProps
> = props => {
  const {
    buttonClick,
    buttonText,
    goalId,
    targetWeight: tWeight,
    currentWeight,
  } = props;

  const { targetWeight, estimatedCompletion } = getGoalSummary({
    targetWeight: tWeight,
    goal: goalId,
    currentWeight,
  });

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1,
        }}>
        <Box
          sx={{
            width: '100%',
            maxWidth: '420px',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Box
            sx={{
              display: 'flex',
              flex: { xs: 3, md: 1 },
              flexDirection: 'column',
              alignItems: { xs: 'flex-start', md: 'center' },
              justifyContent: 'space-between',
              padding: '20px',
            }}>
            <Typography
              sx={{
                fontSize: '22px',
                fontWeight: '500',
                marginTop: 4,
                color: 'white',
                marginBottom: 4,
              }}>
              By following the equ program consistently, we predict you’ll hit
              your target weight of{' '}
              <span
                style={{
                  color: colors.SALAD_HALF,
                }}>
                {targetWeight}kg
              </span>{' '}
              by{' '}
              <span
                style={{
                  color: colors.SALAD_HALF,
                }}>
                {estimatedCompletion}.
              </span>
            </Typography>
            <img
              src={ReinforcerWeightGraph2}
              alt="graph"
              style={{ margin: '10px 0px', width: '90%' }}
            />
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                width: '100%',
              }}>
              <Box
                sx={{
                  borderRadius: '8px',
                  padding: '8px',
                  backgroundColor: colors.CREAM,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <Typography align="center">Your Goal</Typography>
                <Typography fontWeight="bold" align="center">
                  {targetWeight}kg
                </Typography>
              </Box>
            </Box>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: '400',
                marginBlock: '16px',
                color: colors.CREAM_HALF,
              }}>
              Predictions are based on following equ’s scientifically designed
              program consistently and are not a guarantee of results.
            </Typography>
            <Button
              variant="contained"
              onClick={buttonClick}
              size="large"
              sx={{
                textTransform: 'none',
                borderRadius: '100px',
                marginTop: 4,
                width: '330px',
                height: '55px',
                alignSelf: 'center',
                marginBottom: 2,
              }}>
              {buttonText}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};
